import { render, staticRenderFns } from "./InboxToolbarV2026.vue?vue&type=template&id=f2c2b25e&scoped=true"
import script from "./InboxToolbarV2026.vue?vue&type=script&lang=js"
export * from "./InboxToolbarV2026.vue?vue&type=script&lang=js"
import style0 from "./InboxToolbarV2026.vue?vue&type=style&index=0&id=f2c2b25e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c2b25e",
  null
  
)

export default component.exports